module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/male_genitalia-70ced46fb3502db4704bdf84cd61f8d2.png";